<script>

export default {
    name: "StatusTag"
}
</script>

<template>
<div class="status-tag">
    <div class="dot"></div>
    <div>
        <span><slot>Text</slot></span>
    </div>
</div>
</template>

<style scoped lang="scss">
.status-tag {
    /* Badge */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 6px;
    gap: 4px;

    /* Base / White */
    background: #FFFFFF;
    /* Gray/300 */
    border: 1px solid #D5D7DA;
    /* Shadow/xs */
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
    border-radius: 6px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    span {
        /* Text */

        /* Text-xs/Medium */
        font-family: Geist, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        /* identical to box height, or 133% */
        text-align: center;

        /* Gray/700 */
        color: #414651;


        /* Inside auto layout */
        flex: none;
        order: 1;
        flex-grow: 0;

    }
    .dot {
        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;
        /* Dot */
        border-radius: 50%;
        width: 6px;
        height: 6px;
        padding: 2px;
        /* Success/500 */
        background: #17B26A;

    }
}
</style>
